import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function logOut(): AxiosPromise<boolean> {
  return axios.post('api/Account/Logout');
}
